import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';

import type { EntityRowAction } from './entity';

type Props = { actions: EntityRowAction[] };

export const EntityActionsMenu = ({ actions }: Props) => {
  const items: MenuProps['items'] = actions.map((action) => ({
    key: action.key,
    label: action.label,
    disabled: action.disabled,
    onClick: action.onClick,
  }));

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Dropdown menu={{ items }} trigger={['click']}>
        <EllipsisOutlined rotate={90} />
      </Dropdown>
    </div>
  );
};
